module.exports = __webpack_public_path__ + "media/images/emblems/Ittigen-coat_of_arms-6966876d0f35e5b7920e7756e7010a2b.svg";